// eslint-disable-next-line no-restricted-imports
import { AnchorButton } from '@superdispatch/ui-lab';
import { MobileAppBridge } from 'shared/data/MobileAppBridge';
import { WebViewAnchorButton } from 'shared/routing/WebViewLinks';
import {
  getOrderLink,
  getPostingState,
  getViewOfferLink,
  PostingDTO,
} from '../../data/dto/PostingDTO';
import { trackLoadboardEvent } from '../LoadboardAnalytics';

export function renderPostingOfferButton({ load, carrier_load }: PostingDTO) {
  const postingState = getPostingState(load, carrier_load);
  const orderLink = carrier_load && getOrderLink(carrier_load, 'Load Details');
  const offerLink =
    carrier_load && getViewOfferLink(carrier_load, 'Load Details');

  return postingState === 'received_offer' && offerLink ? (
    <WebViewAnchorButton
      fullWidth={true}
      size="large"
      target="_blank"
      href={offerLink}
      onClick={() => {
        trackLoadboardEvent({
          name: 'SLB: Clicked View Load Offer',
          medium: 'details',
          type: 'offer',
        });
      }}
    >
      View Load Offer
    </WebViewAnchorButton>
  ) : !MobileAppBridge.isInjected() && orderLink ? (
    <AnchorButton
      variant="neutral"
      fullWidth={true}
      size="large"
      target="_blank"
      href={orderLink}
      onClick={() => {
        trackLoadboardEvent({
          name: 'SLB: Clicked View Order',
          medium: 'details',
        });
      }}
    >
      View Order
    </AnchorButton>
  ) : null;
}
